import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '../flask.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class LoremIpsum extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('loremIpsum', locale => {

            const view = new ButtonView(locale);

            view.set({
                label: 'Lorem Ipsum',
                icon: imageIcon,
                tooltip: true
            });

            // Callback executed once the button is clicked.

            view.on('execute', async () => {

				//console.log('LoremIpsum clicked');

				const dotnet = editor.config.get( 'loremipsum.dotnet' );

				if (dotnet) {

					//console.log(dotnet);

					var text = await dotnet.invokeMethodAsync('GetRandomLoremIpsum');

					editor.model.change( writer => {

						var textElement = writer.createElement('p');

						writer.insertText(text, textElement);

						editor.model.insertContent(textElement, editor.model.document.selection);

						//console.log(text);
					});
				}
            });

            return view;
        });        

        //console.log( 'LoremIpsum was initialized' );
    }
}
